export enum ThemeList {
  Light = 'light',
  Dark = 'dark',
}

export const DEFAULT_BASE_THEME = ThemeList.Light;
